import { fetchMsisdn, reserveMsisdn } from "../api/api";
import { SequenceManagerAction } from '../actions/SequenceManagerAction';

const ChooseNumberAction = {
    CHOOSE_NUMBER: 'CHOOSE_NUMBER',
    FETCH_MSISDN_SUCCESS: 'FETCH_MSISDN_SUCCESS',
    RESERVE_MSISDN_SUCCESS: 'RESERVE_MSISDN_SUCCESS',
    RESERVE_MSISDN_FAILURE: 'RESERVE_MSISDN_FAILURE',
    FETCH_MSISDN_FAILURE: 'FETCH_MSISDN_FAILURE',
}

const win: any = window
const retryCount = win['AllowedAPIRetryCount'];

let fetchMsisdnCounter = 0;

const fetchMsisdnList = (vanityType: boolean, newStack: any) => {
    return function (dispatch: any) {
        fetchMsisdn(vanityType, newStack).then((response) => {
            dispatch({ type: ChooseNumberAction.FETCH_MSISDN_SUCCESS, payload: response });
        })
            .catch((error) => {
                //Display error
                if (error?.response?.status) {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                } else {
                    ++fetchMsisdnCounter
                    if (fetchMsisdnCounter < retryCount) {
                        const objData = JSON.parse(error?.config?.data);
                        const isVIP = objData?.resourceCapacityDemand?.resourcePool?.options?.package ? true : false;
                        dispatch(fetchMsisdnList(isVIP, objData?.NewStack));
                    } else {
                        dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                    }
                }
            })
    }
}

const reserveNumber = (productType: any, numberType: any, tier: any, numbersList: any, selectedNumber: any, selection: any, offerContainerId: any, newStack: any) => {
    return function (dispatch: any) {
        reserveMsisdn(selection, newStack).then((response) => {
            dispatch({ type: ChooseNumberAction.RESERVE_MSISDN_SUCCESS, payload: { productType: productType, tier: tier, numberType: numberType, numbersList: numbersList, response: response, selectedNumber: selectedNumber, selection: selection, offerContainerId: offerContainerId } });

        })
            .catch((error) => {
                //Display error
                if (error?.response) {
                    dispatch({ type: ChooseNumberAction.RESERVE_MSISDN_SUCCESS, payload: { productType: productType, tier: tier, numberType: numberType, numbersList: numbersList, response: error.response, selectedNumber: selectedNumber, selection: selection, offerContainerId: offerContainerId } });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }
            })
    }
}

const chooseNumberComplete = () => {
    return function (dispatch: any) {
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['ChooseNumber'] });
    };
};

export { ChooseNumberAction, reserveNumber, fetchMsisdnList, chooseNumberComplete };